import React, { useState, useEffect } from 'react';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import { Card, Col, Button, Row } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../common/functions/filterFieldsForList';
import filterDataForList from '../common/functions/filterDataForList';
import schema from './jsonSchema';
import DirectoryService from '../directory/DirectoryService';

const CustomList = () => {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);

  useEffect(() => {
    const jsonSchema = schema;
    setColumns(filterFieldsForList(jsonSchema));

    DirectoryService.retrieveUsersByAccount()
      .then(data => {
        setData(
          filterDataForList(
            data,
            columns.map(c => c.accessor)
          )
        );
        setNoDataToShow(!data.length > 0);
      })
      .catch(error => setError({ error: error.message }));
  }, [data]);
  return (
    <>
      <Card>
        <Card.Body>
          <Row className="flex-between-center">
            <Col md>
              <h5 className="mb-2 mb-md-0">Custom list</h5>
            </Col>
            <Col xs="auto">
              <Button
                size="sm"
                variant="falcon-success"
                href="/social/directory/user-details"
              >
                Create a Custom
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <br />
      {error}
      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any Custom to show. Let's create a new one!
        </Alert>
      )}
      {data && (
        <AdvanceTableWrapper
          columns={columns}
          data={data}
          sortable
          pagination
          perPage={20}
        >
          <AdvanceTable
            table
            headerClassName="bg-200 text-900 text-nowrap align-middle"
            rowClassName="align-middle white-space-nowrap"
            tableProps={{
              bordered: true,
              striped: true,
              className: 'fs--1 mb-0 overflow-hidden'
            }}
          />
          <div className="mt-3">
            <AdvanceTableFooter
              rowCount={data.length}
              table
              rowInfo
              navButtons
              rowsPerPageSelection
            />
          </div>
        </AdvanceTableWrapper>
      )}
    </>
  );
};

export default CustomList;
